import { render, staticRenderFns } from "./InfoCustomer.vue?vue&type=template&id=beef7888&scoped=true&"
import script from "./InfoCustomer.vue?vue&type=script&lang=ts&"
export * from "./InfoCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCustomer.vue?vue&type=style&index=0&id=beef7888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beef7888",
  null
  
)

export default component.exports